import { render } from "./BadgesCarousel.vue?vue&type=template&id=7550523a&scoped=true"
import script from "./BadgesCarousel.vue?vue&type=script&lang=js"
export * from "./BadgesCarousel.vue?vue&type=script&lang=js"

import "./BadgesCarousel.vue?vue&type=style&index=0&id=7550523a&lang=scss&scoped=true"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7550523a"]])

export default __exports__